package com.hyperether.goodjob.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Assignees(
    @SerialName("employees") var employees: List<User?>? = null,
    @SerialName("teams") var teams: List<Team?>? = null,
) {
    fun isDifferent(other: Assignees?): Boolean {
        if (other == null)
            return true
        val differences = mutableListOf<String>()

        // Compare employees lists by comparing each element
        val employeesChanged = when {
            this.employees == null && other.employees != null -> true
            this.employees != null && other.employees == null -> true
            this.employees?.size != other.employees?.size -> true
            else -> {
                this.employees?.zip(other.employees ?: emptyList())
                    ?.any { (thisEmployee, otherEmployee) ->
                        when {
                            thisEmployee == null && otherEmployee != null -> true
                            thisEmployee != null && otherEmployee == null -> true
                            thisEmployee != null && otherEmployee != null -> thisEmployee.isDifferent(
                                otherEmployee
                            )

                            else -> false
                        }
                    } ?: false
            }
        }

        if (employeesChanged) differences.add("employees: different elements found")

        // Compare teams lists by comparing each element
        val teamsChanged = when {
            this.teams == null && other.teams != null -> true
            this.teams != null && other.teams == null -> true
            this.teams?.size != other.teams?.size -> true
            else -> {
                this.teams?.zip(other.teams ?: emptyList())?.any { (thisTeam, otherTeam) ->
                    when {
                        thisTeam == null && otherTeam != null -> true
                        thisTeam != null && otherTeam == null -> true
                        thisTeam != null && otherTeam != null -> thisTeam.isDifferent(otherTeam)
                        else -> false
                    }
                } ?: false
            }
        }

        if (teamsChanged) differences.add("teams: different elements found")

        if (differences.isNotEmpty()) {
            println("Assignees differences found:")
            differences.forEach { println("  - $it") }
            return true
        }

        return false
    }
}
